import { useRouter } from "next/router"
import Script from "next/script"

import { IS_DEV, IS_PROD } from "@/lib/constants"

const HUBSPOT_ACCOUNT_ID_DEV = "40233675"
const HUBSPOT_ACCOUNT_ID_PROD = "20832032"

/**
 * This component loads the Hubspot tracking code.
 * See https://knowledge.hubspot.com/reports/install-the-hubspot-tracking-code
 */
export function HubspotScript() {
  const { asPath, isReady } = useRouter()
  if (!isReady) {
    return null
  } else {
    let hubspotAccountId = null
    // We only want to load the Hubspot script in production and during development.
    if (IS_DEV) {
      hubspotAccountId = HUBSPOT_ACCOUNT_ID_DEV
    } else if (IS_PROD) {
      hubspotAccountId = HUBSPOT_ACCOUNT_ID_PROD
    } else {
      return null
    }

    // Set the path before loading the Hubspot script because the script will send a pageview on
    // initial load.
    // https://developers.hubspot.com/docs/api/events/tracking-code#tracking-in-single-page-applications
    let _hsq = (window._hsq = window._hsq || [])
    _hsq.push(["setPath", asPath])

    return (
      <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src={`//js.hs-scripts.com/${hubspotAccountId}.js`}
      />
    )
  }
}
